import { useState, useEffect } from 'react';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { Button, InnerPageToggleButton } from '@wajeez-web/components/ui';
import {
  useBusinessSelector,
  BusinesssubscriptionActions,
} from '@wajeez-web/stores/business-group';
import AddBusinessSubsicriptionModal from './AddBusinessSubsicriptionModal';
import { useProductSelector, PlansActions } from '@wajeez-web/stores/product';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import { AiOutlinePlus } from 'react-icons/ai';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { DataTableWrapper } from '@wajeez-web/components/helpers';

const BusinessSubsicription = ({
  id,
  title,
}: {
  id: number;
  title: string;
}) => {
  const dispatch = useCommonDispatch();

  const [SubscriptionModalState, setSubscriptionModalState] = useState(false);

  const { data, status } = useBusinessSelector(
    (state) => state.businessSubscription
  );
  const allPlans = useProductSelector((state) => state.plans.data);

  const {
    tablePreferances,
    setTablePreferences,
    getData,
    isTableReferencesLoading,
  } = HandleTableData(
    'businessSubscription',
    BusinesssubscriptionActions.getBusinessGroupsubscriptionDatatableAsync,
    undefined,
    { businessGroupId: id }
  );

  useEffect(() => {
    dispatch(PlansActions.getAllPlansAsync());
  }, [dispatch]);

  return (
    <>
      {SubscriptionModalState && (
        <AddBusinessSubsicriptionModal
          allPlans={
            allPlans.map((plan) => ({
              value: plan.id || 0,
              label: plan.referenceName || '',
            })) || []
          }
          isOpen={SubscriptionModalState}
          onClose={() => {
            setSubscriptionModalState(false);
          }}
          onSubmit={(businessSubscriptionValues) => {
            dispatch(
              BusinesssubscriptionActions.createNewBusinessGroupsubscriptionAsync(
                { businessGroupId: Number(id), ...businessSubscriptionValues }
              )
            ).then(() => {
              setSubscriptionModalState(false);
              getData();
            });
          }}
        />
      )}
      <div className="space-y-6">
        <div className="flex justify-between">
          <div>
            <h3 className="ms-2 lg:ms-0 text-2xl flex align-middle font-bold space-s-2 tracking-tight leading-none  ">
              {<InnerPageToggleButton />} <div className="mt-1">{title}</div>
            </h3>
            <p className=" text-sm text-gray-600"></p>
          </div>
          <Button
            color="white"
            title="Add New Subscription"
            bg="primary"
            Icon={AiOutlinePlus}
            onClick={() => {
              setSubscriptionModalState(true);
            }}
          />
        </div>
        <DataTableWrapper
          data={data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={status === 'loading'}
          rowActions={(row) => {
            return [
              {
                title: 'Expire',
                permission: '92.2',
                type: 'request',
                endpoint: '',
                action: async () => {
                  const res = await dispatch(
                    BusinesssubscriptionActions.expireBusinessGroupsubscriptionAsync(
                      {
                        businessGroupSubscriptionId: Number(row[1]),
                      }
                    )
                  );

                  if (res.meta.requestStatus === 'fulfilled') {
                    getData();
                  }
                },
              },
            ];
          }}
          preferences={tablePreferances || undefined}
          setPreferences={setTablePreferences}
        />
      </div>
    </>
  );
};

export default BusinessSubsicription;
